import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

export const Loading = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
        position: 'absolute',
        background: 'rgba(0,0,0,0.5)',
        top: 0,
        left: 0,
        zIndex: 1500,
      }}
    >
      <CircularProgress size={100} />
    </Box>
  );
};
